import { useCallback, useContext } from 'react';
import { snowplowFireUiInteractionEvent } from '@at/track-core';
import { trackUtagEventWhenReady } from '@at/sauron-tracking/lib/utils/index';
import { ATConsumerTrackingStateContext } from '../../tracking-context/ATTracking.context';
/**
 * This is the base hook that is used internally for each hook that a consumer SPA use.
 * Fire UI Interaction event with ATDS entity context, label, action and utag dimensions etc.
 */
export var useATFireUIInteractionEvent = function () {
    var _a = useContext(ATConsumerTrackingStateContext), skipTracking = _a.skipTracking, withCombinedEntities = _a.withCombinedEntities;
    var interactionEvent = useCallback(function (_a) {
        var _b = _a.interaction, interaction = _b === void 0 ? 'click' : _b, _c = _a.trackingLabel, trackingLabel = _c === void 0 ? '' : _c, customiseEntities = _a.customiseEntities, utagDimensions = _a.utagDimensions;
        if (skipTracking)
            return;
        var mergedEntities = withCombinedEntities([]);
        // Add to Utag tracking
        trackUtagEventWhenReady({
            label: trackingLabel,
            action: interaction,
            category: utagDimensions === null || utagDimensions === void 0 ? void 0 : utagDimensions.category,
        });
        return snowplowFireUiInteractionEvent(trackingLabel, interaction, (customiseEntities === null || customiseEntities === void 0 ? void 0 : customiseEntities(mergedEntities)) || mergedEntities);
    }, [skipTracking, withCombinedEntities]);
    return interactionEvent;
};
